import React from "react";
import styles from "./UploadSelection.module.scss";
import { cross } from "../icons";
import SpinLogoBlack from "../../../static/images/logo/spinByLablacoLogoBlack.svg";
import SpinLogoMinimal from "../../../static/images/logo/spinConnectMinimal.svg";
import windows from "../../../static/icons/windows.svg";
import apple from "../../../static/icons/apple.svg";
import ModalBottom from "../ModalBottom";
import closeButton from "../../../static/icons/close.svg";
import Button from "../../Button";

export default ({ _, onClose }) => {
  const handleMacDownload = async () => {
    const yml = await fetch(
      "https://spinos-releases.s3.us-east-1.amazonaws.com/macos-signed-latest/latest-mac.yml"
    ).then((r) => r.text());
    const { fileName, fileLink } = getFileNameLink(
      /url:.*.dmg/gm,
      "macos",
      yml
    );
    startDownload(fileName, fileLink);
  };
  const handleWindowsDownload = async () => {
    const yml = await fetch(
      "https://spinos-releases.s3.us-east-1.amazonaws.com/windows-signed-latest/latest.yml"
    ).then((r) => r.text());
    const { fileName, fileLink } = getFileNameLink(
      /url:.*.exe/gm,
      "windows",
      yml
    );
    startDownload(fileName, fileLink);
  };

  const startDownload = (fileName, fileLink) => {
    const link = document.createElement("a");
    link.href = fileLink;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    setTimeout(() => onClose(), 350);
  };

  const getFileNameLink = (r, system, yml) => {
    const fileName = yml.match(r)[0].replace("url: ", "");
    const fileLink = `https://spinos-releases.s3.us-east-1.amazonaws.com/${system}-signed-latest/${fileName}`;
    return { fileName, fileLink };
  };

  return (
    <ModalBottom isOpen onClose={onClose}>
      <div className={styles.UploadSelectionModal}>
        <div className={styles.header}>
          <div className={styles.backButton} onClick={onClose}>
            <img src={closeButton} alt="" />
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.information}> i</div>
          <div className={styles.title}>Download SPIN OS app</div>
          <div className={styles.subMessage}>
            To start minting your Phygital NFTs, please download the SPIN
            Connect app on your desktop computer.
          </div>

          <div className={styles.buttonContainer}>
            <Button
              type="button"
              size="large"
              onClick={handleMacDownload}
              className={styles.okButton}
            >
              <img src={apple} />
              <span>Download for Mac</span>
            </Button>

            <Button
              type="button"
              size="large"
              onClick={handleWindowsDownload}
              className={styles.okButton}
            >
              <>
                <img src={windows} />
              </>
              <span>Download for Windows</span>
            </Button>
          </div>
        </div>
      </div>
      
    </ModalBottom>
  );
};
